<template>
  <div class="animated fadeIn text-center">
    <b-row v-if="db_update_available">
      <b-col sm="7">
        <Bell style="position: absolute;" :size="20" :count="1" v-if="db_update_available_latest()"/>
        GEOデータベース最終更新 :
      </b-col>
      <b-col sm="2" class="text-left">
        {{ mmdb_version }}
      </b-col>
      <b-col>
        <b-button :style="!db_update_available_latest() ? 'cursor: not-allowed;' : ''" :disabled="!db_update_available_latest()" size="sm" variant="outline-success" block @click="update">DBアップデート</b-button>
      </b-col>
      <b-col sm="1">
        <div class="pull-right">
          <b-button size="sm" variant="outline-info" @click="explain_modal_mmdb = true"><i class="fa fa-question"></i></b-button>
        </div>
      </b-col>
    </b-row>
    <hr v-if="_show_toogle_button != false">
    <b-row v-if="_show_toogle_button != false">
      <b-col sm="8">
        IPアドレスから国名情報を取得する(GEO-IP)
      </b-col>
      <b-col sm="3" class="text-left">
        <c-switch color="success" label variant="pill" size="sm" defaultChecked v-model="use_geoip" @change="change_use_geoip"/>
      </b-col>
      <b-col sm="1">
        <div class="pull-right">
          <b-button size="sm" variant="outline-info" @click="explain_modal_code = true"><i class="fa fa-question"></i></b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="4">
        ファイヤーウォールモードを適用する国を選んでください
      </b-col>
      <b-col sm="6">
        <b-form-input :disabled="!use_geoip" style="display:inline-block" v-model="country" placeholder="Enter Country name"></b-form-input>
      </b-col>
      <b-col sm="2" class="text-left">
        <b-form-checkbox :disabled="!use_geoip" v-model="select_all" @change="toggle_all">
          全ての国を選択
        </b-form-checkbox>
        <b-form-checkbox :disabled="!use_geoip" v-model="show_block_only" @change="save_show_status">
          入力した国のみ
        </b-form-checkbox>
      </b-col>
    </b-row>
    <hr v-if="!hide_count">
    <b-row v-if="!hide_count">
      <b-col sm="4">
        国を選択
      </b-col>
      <b-col sm="8">
        {{country_code.length}}
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="12">
        <div class="pr-2 pl-2" v-show="(country && show_block_only && is_show(x)) || (is_show(x) && !show_block_only) || (show_block_only && x.is_block)" v-for="(x, index) in country_info" style="min-width:75px; height:75px; display:inline-block;">
          <b-form-checkbox :disabled="!use_geoip" style="cursor:pointer;" v-model="x.is_block" class="is_check" @change="onSelect(x.Code, x.Name)">
            <span style="cursor:pointer;" v-if="x.Code" class="flag-icon" :class="set_flag(x.Code)"></span>
            <p :style="x.is_block ? 'font-weight:900' : ''">{{ country ? x.Name : x.Code}}</p>
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="ブロックベース国コード"  class="modal-info" v-model="explain_modal_code" ok-variant="success" header-bg-variant="success" ok-only>
      <p>国番号ブロックの場合は、GEO-IP機能でIPを国番号に変換する必要があります。</p>
      <p>123.123.123.123 	&rArr; KR  </p>
    </b-modal>
    <!-- mmdb 업데이트 설명 모달 영역 -->
    <b-modal title="データベース情報"  class="modal-info" v-model="explain_modal_mmdb" ok-variant="success" header-bg-variant="success" ok-only>
      GeoIPデータベース 最新配布バージョン : {{ mmdb_latest }}
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
